var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parallax-container"},[_c('ul',{staticClass:"container collapsible"},[_c('li',{staticClass:"active"},[_c('LoginSection')],1),_c('li',[_c('DashboardSection')],1)]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parallax"},[_c('img',{attrs:{"src":require("../assets/gombessa1.jpg"),"alt":"Unsplashed background img 1"}})])
}]

export { render, staticRenderFns }